export const environment = {
    production: true,
    apiUrl: '/api',
    keycloak: {
        url: 'https://keycloak.localys.shop',
        realm: 'localys-realm',
        clientId: 'localys-frontend'
    }
};
